import { Wrapper } from "../../../assets/wrappers/Loading"

export const Loading = ({ centre }: any) => {
  return (
    <Wrapper>
      <div className={centre ? 'lds-spinner centre' : 'loading'}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </Wrapper>
  )
}